import { pathnameToPathList } from 'annotation-tools/utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay } from 'rxjs/operators';

const pathnameSource = new BehaviorSubject<string>('');
export const updatePathname = (url: string) => pathnameSource.next(url);
const pathname$: Observable<string> = pathnameSource.asObservable().pipe(
  filter(e => e !== ''),
  distinctUntilChanged()
);

export const pathList$: Observable<string[]> = pathname$.pipe(
  map(pathnameToPathList),
  shareReplay(1)
);
